// src/components/foam/FoamChat.js
//
// SUPPORT screen (`/boards/:sku/support`) — Nigel, 2026-06-05.
// Native Foam-styled Viento chat (no iframe, no widget chrome) — see
// FoamVientoChat.js. The greeting bubble is local; the conversation hits
// the same chat backend the website widget uses.

import React from 'react';
import { FPage, FHeader, FLabel, FHeadline } from './FoamPrimitives';
import FoamVientoChat from './FoamVientoChat';

const FoamChat = ({ onBack }) => (
  <FPage>
    <FHeader right={
      <button type="button" onClick={onBack} className="font-sans text-[14px] text-foam-ink">
        Back
      </button>
    } />

    <FLabel>Support · Viento</FLabel>

    <FHeadline size={50} lineHeight={0.92}>
      How can we<br /><FHeadline.Accent>support you?</FHeadline.Accent>
    </FHeadline>

    <FoamVientoChat
      greeting="Hey! I'm Viento, WAKA's product specialist. Ask me anything — board care, warranty, sizing, shipping — and I'll loop in the team for anything complex."
    />
  </FPage>
);

export default FoamChat;
